import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { FaPrint, FaTrash, FaSearch, FaFileInvoice, FaTimes, 
  FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';

import PrintSaleInvoice from '../Store/PrintSaleInvoice';
import Puff from 'react-loading-icons/dist/esm/components/puff';
import Swal from 'sweetalert2';
import { useStateContext } from '../Context/ContextProvider';

function MyInvoices() {
    const [invoices, setInvoices] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [printData, setPrintData] = useState([]);
    const [isPrint, setIsPrint] = useState(false);
    const [isClick, setIsClick] = useState('');
    const [norecord, setNoRecord] = useState(false);
   
    const { userId } = useStateContext();

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const clearSearch = () => {
        setSearchQuery('');
        setCurrentPage(1);
    };

    const handleDelInvoice = (id, index) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This action will permanently delete the invoice!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel',
            reverseButtons: true,
            confirmButtonColor: '#ff4757',
            cancelButtonColor: '#7a8a9e',
        }).then((result) => {
            if (result.isConfirmed) {
                setIsClick(index);
                const data = { 'id': id };
                axios.post(`api/delete/invoice`, data).then(res => {
                    if (res.data.msg === '0') {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'warning',
                            title: 'Day has been closed',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        setIsClick(false);
                        return false;
                    } else {
                        if (res.data.status === 200) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: res.data.message,
                                showConfirmButton: false,
                                timer: 1500,
                                timerProgressBar: true,
                            });
                            setIsClick(false);
                        }
                    }
                }).catch(error => {
                    console.error("There was an error deleting the invoice:", error);
                    setIsClick(false);
                });
            }
        });
    };

    useEffect(() => {
        const data = { 'id': userId }
        axios.post(`/api/myinvoices?page=${currentPage}&search=${searchQuery}`, data).then(response => {
            setInvoices(response.data.invoices.data);
            setTotalPages(response.data.invoices.last_page);
            if ((response.data.invoices.data).length === 0) {
                setNoRecord(true);
            } else {
                setNoRecord(false);
            }
        })
    }, [currentPage, searchQuery, isClick, userId]);

    const handleReInvoice = (e, id, index) => {
        e.preventDefault();
        setIsClick(index);
        const data = { 'id': id }
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post('/api/reinvoice/print', data).then(res => {
                const printDatas = {
                    letter: res.data.cart,
                    dates: res.data.dates,
                    salestax: res.data.salestax,
                    discount: res.data.discount,
                    grandtotal: res.data.grandtotal,
                    invoiceno: res.data.invoiceno,
                    remainingbill: res.data.remainingbill,
                    customer: res.data.customer,
                    customeraddress: res.data.customeraddress,
                    salesman: res.data.salesman,
                    payment: res.data.payment,
                    totalpay: res.data.totalpay,
                    pbalance: res.data.pbalance,
                    recovery: res.data.recovery,
                    printingtime: res.data.printingtime,
                    manualdate: res.data.manualdate,
                    detail: res.data.detail,
                    imagesrc: res.data.detail,
                    shipping: res.data.shipping,
                    entercash: res.data.entercash,
                    // Add additional fields needed for POS invoice
                    wholesale_tax: res.data.wholesale_tax || 0,
                    store_name: res.data.store_name || '',
                    store_address: res.data.store_address || '',
                    store_phone: res.data.store_phone || '',
                    cnic: res.data.cnic || '',
                    gst: res.data.gst || ''
                }
                setPrintData(printDatas);
                setIsPrint(true);
            });
        });
    }

    useEffect(() => {
        if (isPrint) {
            // Use the PrintSaleInvoice component which renders full POS invoice
            var div = document.getElementById('printablearea');
            if (div) {
                var win = window.open('', '_blank', 'height=700,width=800');
                win.document.write(`
                    <!DOCTYPE html>
                    <html>
                        <head>
                            <title>Invoice #${printData.invoiceno}</title>
                            <style>
                                body { 
                                    margin: 0; 
                                    padding: 0; 
                                    font-family: Arial, sans-serif;
                                    background: #f5f5f5;
                                }
                                @media print {
                                    body { background: white; }
                                    .no-print { display: none !important; }
                                }
                            </style>
                        </head>
                        <body>
                            ${div.outerHTML}
                        </body>
                    </html>
                `);
                win.document.close();
                setTimeout(() => {
                    win.print();
                    win.close();
                }, 1000);
            }
            setIsPrint(false);
            setIsClick('');
        }
    }, [isPrint, printData]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-PK', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    return (
        <div className="my-invoices-container">
            <style>{`
                .my-invoices-container {
                    max-width: 100%;
                    padding: 16px 20px 30px 20px;
                    background: #f5f7fa;
                    min-height: 100vh;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                }

                /* Header */
                .invoices-header {
                    background: linear-gradient(135deg, #4a6cf7, #6b4cf7);
                    border-radius: 16px;
                    padding: 20px 24px;
                    margin-bottom: 20px;
                    color: white;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 12px;
                }

                .invoices-header-title {
                    font-size: 20px;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .invoices-header-title svg {
                    font-size: 24px;
                }

                .invoices-header-badge {
                    background: rgba(255,255,255,0.2);
                    padding: 6px 16px;
                    border-radius: 50px;
                    font-size: 13px;
                    font-weight: 600;
                }

                /* Search Bar */
                .search-wrapper {
                    position: relative;
                    margin-bottom: 16px;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 44px 12px 44px;
                    border: 2px solid #e9ecef;
                    border-radius: 12px;
                    font-size: 14px;
                    outline: none;
                    background: white;
                    transition: all 0.3s ease;
                }

                .search-input:focus {
                    border-color: #4a6cf7;
                    box-shadow: 0 0 0 4px rgba(74, 108, 247, 0.1);
                }

                .search-icon {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #7a8a9e;
                    font-size: 18px;
                }

                .search-clear {
                    position: absolute;
                    right: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: none;
                    border: none;
                    color: #7a8a9e;
                    font-size: 18px;
                    cursor: pointer;
                    padding: 4px;
                    border-radius: 50%;
                    transition: all 0.3s ease;
                }

                .search-clear:hover {
                    background: #f1f3f5;
                    color: #ff4757;
                }

                /* Table Wrapper */
                .table-wrapper {
                    background: white;
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #e9ecef;
                    overflow-x: auto;
                    margin-bottom: 16px;
                }

                .table-wrapper table {
                    width: 100%;
                    border-collapse: collapse;
                    min-width: 700px;
                    font-size: 13px;
                }

                .table-wrapper thead {
                    background: linear-gradient(135deg, #1a2332, #2c3e50);
                    color: white;
                }

                .table-wrapper thead th {
                    padding: 12px 14px;
                    text-align: left;
                    font-weight: 600;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    white-space: nowrap;
                }

                .table-wrapper tbody tr {
                    transition: all 0.2s ease;
                    border-bottom: 1px solid #f1f3f5;
                }

                .table-wrapper tbody tr:hover {
                    background: #f8f9fc !important;
                }

                .table-wrapper tbody td {
                    padding: 10px 14px;
                    vertical-align: middle;
                }

                .table-wrapper tbody tr:last-child {
                    border-bottom: none;
                }

                /* Row Colors */
                .row-low-stock {
                    background: #fff5f5 !important;
                }

                .row-low-stock:hover {
                    background: #ffebeb !important;
                }

                .row-hold {
                    background: #fef2f2 !important;
                }

                .row-hold:hover {
                    background: #fde8e8 !important;
                }

                .row-success {
                    background: #f0fdf4 !important;
                }

                .row-success:hover {
                    background: #dcfce7 !important;
                }

                /* Invoice Number */
                .invoice-number {
                    font-weight: 700;
                    color: #4a6cf7;
                    font-family: monospace;
                    font-size: 14px;
                }

                /* Status Badge */
                .status-badge {
                    display: inline-block;
                    padding: 3px 12px;
                    border-radius: 50px;
                    font-size: 11px;
                    font-weight: 600;
                    text-transform: capitalize;
                }

                .status-badge.sale {
                    background: #e3f2fd;
                    color: #1976d2;
                }

                .status-badge.return {
                    background: #fff3e0;
                    color: #e65100;
                }

                /* Amount */
                .amount {
                    font-weight: 600;
                    color: #1a2332;
                }

                .amount-highlight {
                    color: #2ecc71;
                }

                /* Actions */
                .action-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 6px 10px;
                    border: none;
                    border-radius: 8px;
                    font-size: 13px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    gap: 4px;
                    min-width: 36px;
                }

                .action-btn:active {
                    transform: scale(0.95);
                }

                .action-btn-delete {
                    background: #fef2f2;
                    color: #ff4757;
                }

                .action-btn-delete:hover {
                    background: #ff4757;
                    color: white;
                }

                .action-btn-print {
                    background: #e3f2fd;
                    color: #1976d2;
                }

                .action-btn-print:hover {
                    background: #1976d2;
                    color: white;
                }

                .action-btn:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                .action-group {
                    display: flex;
                    gap: 6px;
                }

                /* Pagination */
                .pagination-wrapper {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 0;
                    background: white;
                    border-radius: 12px;
                    border: 1px solid #e9ecef;
                }

                .pagination-btn {
                    padding: 8px 16px;
                    border: none;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    touch-action: manipulation;
                }

                .pagination-btn:active {
                    transform: scale(0.95);
                }

                .pagination-btn-prev {
                    background: #f1f3f5;
                    color: #1a2332;
                }

                .pagination-btn-prev:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }

                .pagination-btn-next {
                    background: linear-gradient(135deg, #4a6cf7, #6b4cf7);
                    color: white;
                }

                .pagination-btn-next:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }

                .pagination-info {
                    font-size: 13px;
                    color: #7a8a9e;
                }

                .pagination-info strong {
                    color: #1a2332;
                }

                /* No Record */
                .no-record {
                    text-align: center;
                    padding: 60px 20px;
                    color: #7a8a9e;
                }

                .no-record svg {
                    font-size: 48px;
                    color: #e9ecef;
                    margin-bottom: 12px;
                }

                .no-record h3 {
                    color: #1a2332;
                    margin-bottom: 4px;
                }

                .no-record p {
                    font-size: 14px;
                }

                /* Loading */
                .loading-center {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 40px;
                }

                /* Print Button Styles */
                .print-btn-wrapper {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: #e3f2fd;
                    color: #1976d2;
                    padding: 6px 14px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-weight: 600;
                    border: none;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .print-btn-wrapper:hover {
                    background: #1976d2;
                    color: white;
                }

                /* Responsive */
                @media (max-width: 768px) {
                    .my-invoices-container {
                        padding: 10px 10px 20px 10px;
                    }
                    .invoices-header {
                        padding: 16px 18px;
                    }
                    .invoices-header-title {
                        font-size: 17px;
                    }
                    .invoices-header-badge {
                        font-size: 11px;
                        padding: 4px 12px;
                    }
                    .table-wrapper table {
                        font-size: 12px;
                        min-width: 600px;
                    }
                    .table-wrapper thead th {
                        padding: 8px 10px;
                        font-size: 10px;
                    }
                    .table-wrapper tbody td {
                        padding: 8px 10px;
                    }
                    .action-btn {
                        padding: 4px 8px;
                        font-size: 12px;
                        min-width: 30px;
                    }
                    .pagination-wrapper {
                        padding: 10px 0;
                        gap: 8px;
                    }
                    .pagination-btn {
                        font-size: 12px;
                        padding: 6px 12px;
                    }
                }

                @media (max-width: 576px) {
                    .my-invoices-container {
                        padding: 6px 6px 16px 6px;
                    }
                    .invoices-header {
                        padding: 12px 14px;
                        border-radius: 12px;
                    }
                    .invoices-header-title {
                        font-size: 15px;
                    }
                    .invoices-header-title svg {
                        font-size: 18px;
                    }
                    .search-input {
                        font-size: 13px;
                        padding: 10px 36px 10px 36px;
                    }
                    .table-wrapper {
                        border-radius: 12px;
                    }
                    .table-wrapper table {
                        font-size: 11px;
                        min-width: 500px;
                    }
                    .table-wrapper thead th {
                        padding: 6px 8px;
                        font-size: 9px;
                    }
                    .table-wrapper tbody td {
                        padding: 6px 8px;
                    }
                    .invoice-number {
                        font-size: 12px;
                    }
                    .action-group {
                        flex-direction: column;
                        gap: 4px;
                    }
                    .action-btn {
                        padding: 4px 6px;
                        font-size: 11px;
                        min-width: 28px;
                    }
                    .pagination-btn {
                        font-size: 11px;
                        padding: 4px 10px;
                    }
                    .pagination-info {
                        font-size: 11px;
                    }
                }

                /* Touch-friendly */
                @media (hover: none) {
                    .table-wrapper tbody tr:hover {
                        background: inherit !important;
                    }
                    .row-low-stock:hover {
                        background: #fff5f5 !important;
                    }
                    .row-hold:hover {
                        background: #fef2f2 !important;
                    }
                    .row-success:hover {
                        background: #f0fdf4 !important;
                    }
                }
            `}</style>

            {/* Header */}
            <div className="invoices-header">
                <div className="invoices-header-title">
                    <FaFileInvoice />
                    My Invoices
                </div>
                <div className="invoices-header-badge">
                    <FaFileInvoice /> {invoices.length} invoices found
                </div>
            </div>

            {/* Search */}
            <div className="search-wrapper">
                <FaSearch className="search-icon" />
                <input
                    type="text"
                    className="search-input"
                    placeholder="Search by invoice, customer, or date..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                />
                {searchQuery && (
                    <button className="search-clear" onClick={clearSearch}>
                        <FaTimes />
                    </button>
                )}
            </div>

            {/* Table */}
            <div className="table-wrapper">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Invoice No</th>
                            <th>Customer</th>
                            <th>SubSector</th>
                            <th>Total</th>
                            <th>Received</th>
                            <th>Discount</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {norecord ? (
                            <tr>
                                <td colSpan="10">
                                    <div className="no-record">
                                        <FaFileInvoice />
                                        <h3>No Invoices Found</h3>
                                        <p>Try adjusting your search or create a new invoice</p>
                                    </div>
                                </td>
                            </tr>
                        ) : invoices && invoices.length > 0 ? (
                            invoices.map((item, index) => (
                                <tr 
                                    key={item.id} 
                                    className={
                                        item.qty < 15 ? 'row-low-stock' : 
                                        item.hold === '2' ? 'row-hold' : 
                                        'row-success'
                                    }
                                >
                                    <td>{index + 1}</td>
                                    <td className="invoice-number">{item.visitor_id}</td>
                                    <td><strong>{item.customername}</strong></td>
                                    <td>{item.subsectorname || '-'}</td>
                                    <td className="amount">Rs {parseFloat(item.total).toFixed(2)}</td>
                                    <td className="amount amount-highlight">Rs {parseFloat(item.cash_recieved).toFixed(2)}</td>
                                    <td>Rs {parseFloat(item.discount).toFixed(2)}</td>
                                    <td>{formatDate(item.invoice_date)}</td>
                                    <td>
                                        <span className={`status-badge ${item.type === 'Sale Invoice' ? 'sale' : 'return'}`}>
                                            {item.type === 'Sale Invoice' ? 'Sale' : 'Return'}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="action-group">
                                            <button 
                                                onClick={(e) => handleDelInvoice(item.visitor_id, index)} 
                                                className="action-btn action-btn-delete"
                                                disabled={isClick === index}
                                            >
                                                {isClick === index ? <Puff width={14} height={14} /> : <FaTrash />}
                                            </button>
                                            <button 
                                                disabled={isClick === index} 
                                                onClick={(e) => handleReInvoice(e, item.visitor_id, index)} 
                                                className="action-btn action-btn-print"
                                                title="Print Full POS Invoice"
                                            >
                                                {isClick === index ? <Puff width={14} height={14} /> : <FaPrint />}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="10">
                                    <div className="loading-center">
                                        <Puff stroke="#4a6cf7" />
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {/* Pagination */}
            {invoices && invoices.length > 0 && (
                <div className="pagination-wrapper">
                    <button
                        className="pagination-btn pagination-btn-prev"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((page) => page - 1)}
                    >
                        <FaChevronLeft /> Previous
                    </button>
                    <span className="pagination-info">
                        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    </span>
                    <button
                        className="pagination-btn pagination-btn-next"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((page) => page + 1)}
                    >
                        Next <FaChevronRight />
                    </button>
                </div>
            )}

            {/* Hidden Print Area - Uses PrintSaleInvoice component for full POS invoice */}
            <div style={{ display: 'none' }}>
                {isPrint && <PrintSaleInvoice data={printData} />}
            </div>
        </div>
    )
}

export default MyInvoices